export default {
    index: {
        listagem_setores: 'Listado de Sectores',
        setor_nao_encontrado: 'No se encontró ningún sector',
        criar_setor: 'Crear Sector',
        editar: 'Editar',
        nome: 'Nombre',
        apelido: 'Apodo'
    },
    form: {
        setores: 'Sectores',
        unidade_atendimento_principal: 'Unidad de Atención Principal',
        informacoes: 'Información',
        nome: 'Nombre',
        nome_descricao: 'Nombre del Sector',
        mnemonico: 'Mnemónico',
        mnemonico_descricao: 'Mnemónico del Sector',
        veus_id_descricao: 'ID del Sector en Veus Saúde',
        vinculo: 'Vínculo',
        unidade_atendimento_principal_descricao: 'Unidad de Atención Principal',
        setor_criado_sucesso: '¡Sector creado con éxito!',
        setor_atualizado_sucesso: '¡Sector actualizado con éxito!'
    }       
}